import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WhatsAppService {

  public readonly eagleTechPhoneNumber = '573203405747';
  private readonly WHATSAPP_BASE_URL = 'https://wa.me/';

  constructor() { }

  /**
   * Abre el chat de soporte general de la empresa.
   */
  openGeneralSupportChat(): void {
    const message = 'Hola, necesito asesoría con un perfume de Altair Parfum.';
    this.openChat(this.eagleTechPhoneNumber, message);
  }

  /**
   * Abre una ventana de chat de WhatsApp con un número y mensaje predefinido.
   * @param phone El número de teléfono, incluyendo el código de país (ej: 573101234567).
   * @param message El mensaje pre-llenado para enviar.
   */
  openChat(phone: string, message: string = ''): void {
    if (!phone) {
      console.error('Número de teléfono no proporcionado.');
      return;
    }
    const encodedMessage = encodeURIComponent(message);
    const url = `${this.WHATSAPP_BASE_URL}${phone}?text=${encodedMessage}`;
    window.open(url, '_blank');
  }
}
